export default "__VITE_ASSET__CdIAeMEi__"